import React, { useState, useEffect } from "react";
import Select from "react-select";
import { primaryColor } from "../../Constants";


function CustomDropdown({
  value,
  name,
  handleChange,
  placeholder,
  options,
  handleGetOptionValue,
  handleGetOptionName,
  isDisabled = false,
  customClasses,
  hideDropdownIndicator = false,
}) {
  const [isFocused, setIsFocused] = useState(false);


  useEffect(() => {
    if (value) {
      setIsFocused(true);
    }
  }, [value]);

  return (
    <div className="relative w-full bg-white">
      {/* Floating Label */}
      <label
        className={`absolute left-3 transition-all z-10 bg-white px-1
          ${
            isFocused || value
              ? "top-[-10px] text-xs text-blue-600 px-1 bg-white"
              : "top-2/4 text-gray-400 text-sm -translate-y-1/2"
          }
        `}
      >
        {placeholder}
      </label>

      {/* Select Dropdown */}
      <Select
        value={value}
        name={name}
        onChange={(selectedOption) => {
          handleChange(selectedOption);
          setIsFocused(!!selectedOption);
        }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => {
          if (!value) setIsFocused(false);
        }}
        className={`mt-1 ${customClasses}`}
        options={options || []}
        getOptionValue={handleGetOptionValue}
        getOptionLabel={handleGetOptionName}
        isDisabled={isDisabled}
        placeholder="" // Removes the extra "Select..." label
        menuPortalTarget={document.body} // Ensures menu appears above everything
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor: value || state.isFocused ? "#2563EB" : "#E5E7EB",
            borderWidth: "1px",
            borderRadius: "6px",
            boxShadow: "none",
            "&:hover": {
              borderColor: "#2563EB",
            },
            minHeight: "38px",
            height: "38px",
            padding: "0 8px",
            backgroundColor: "#FFFFFF",
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999, // Higher z-index than the floating label
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            borderRadius: "6px",
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "#EFF6FF" : state.isFocused ? "#F9FAFB" : "white",
            color: state.isSelected ? "#2563EB" : "#374151",
            "&:hover": {
              backgroundColor: "#F9FAFB",
            },
            fontSize: "0.875rem",
            padding: "8px 12px",
          }),
          valueContainer: (base) => ({
            ...base,
            padding: "2px 8px",
            fontSize: "0.875rem",
          }),
          indicatorsContainer: (base) => ({
            ...base,
            height: "36px",
          }),
          dropdownIndicator: (base) => ({
            ...base,
            padding: "4px",
            color: "#6B7280",
            display: hideDropdownIndicator ? 'none' : base.display,
            "&:hover": {
              color: "#374151",
            },
          }),
          singleValue: (base) => ({
            ...base,
            color: "#374151",
          }),
          placeholder: (base) => ({
            ...base,
            color: "#9CA3AF",
          }),
          indicatorSeparator: (base) => ({
            ...base,
            display: hideDropdownIndicator ? 'none' : base.display,
          }),
        }}
      />
    </div>
  );
}

export default CustomDropdown;